import { apolloClient } from "../apolloClient";
import {
  CREATE_QA_CLIENT_FILE,
  CREATE_QA_FILE,
  CREATE_QA_SUMMARY_FILE,
} from "../queries/qaServices";
import { CREATE_SCM_FILE } from "../queries/scmServices";
import { summaryServiceLines } from "../views/QAService/QAReportUploadModal/components/ReportUploadForm";

const createFileMutation = async ({ mutation, variables }) => {
  const res = await apolloClient.mutate({
    mutation,
    variables,
  });

  return res;
};

export const createQAFiles = async (params) => {
  const {
    formValues,
    summaryReport,
    parentId,
    clientId,
    projectId,
    clientReport,
    onFileCreate,
  } = params;

  const fileServiceName = [];
  const { serviceLine, link } = formValues;

  if (summaryReport) {
    const serviceName = summaryServiceLines.find(
      (item) => item.label === serviceLine
    );

    fileServiceName.push("summary", serviceName?.value ?? "common");
  } else if (params.clientReport) {
    fileServiceName.push("common");
  }

  const uploadedFiles = [];
  let parentName = null;
  let folderId = parentId;

  for (const item of link) {
    if (summaryReport) {
      const { data } = await createFileMutation({
        mutation: CREATE_QA_SUMMARY_FILE,
        variables: {
          data: {
            name: item.name,
            link: item.link,
            serviceLine: fileServiceName,
            projectId: +projectId,
            parentId,
          },
        },
      });

      const { id } = data.createQASummaryFile;

      if (!parentName) {
        parentName = data.createQASummaryFile.parentName;
        folderId = data.createQASummaryFile.parentId;
      }

      uploadedFiles.push({
        link: item.link,
        name: item.name,
        parentId: folderId,
        id,
        projectId: +projectId,
        serviceLine: fileServiceName,
      });
    } else if (clientReport) {
      const { data } = await createFileMutation({
        mutation: CREATE_QA_CLIENT_FILE,
        variables: {
          data: {
            name: item.name,
            link: item.link,
            parentId,
            clientId,
          },
        },
      });

      const { id } = data.createQAClientFile;

      if (!parentName) {
        parentName = data.createQAClientFile.parentName;
        folderId = data.createQAClientFile.parentId;
      }

      uploadedFiles.push({
        link: item.link,
        name: item.name,
        parentId: folderId,
        id,
        clientId,
        serviceLine: ["common"],
      });
    } else {
      const { data } = await createFileMutation({
        mutation: CREATE_QA_FILE,
        variables: {
          data: {
            name: item.name,
            link: item.link,
            projectId: +projectId,
            parentId,
          },
        },
      });

      const { id } = data.createQAFile;

      if (!parentName) {
        parentName = data.createQAFile.parentName;
        folderId = data.createQAFile.parentId;
      }

      uploadedFiles.push({
        link: item.link,
        name: item.name,
        parentId: folderId,
        id,
        projectId: +projectId,
        serviceLine: fileServiceName,
      });
    }
  }

  onFileCreate(uploadedFiles, { parentName, parentId: folderId });
};

export const createSCMFiles = async (params) => {
  const { formValues, organizationId, parentId } = params;
  const { link } = formValues;

  await createFileMutation({
    mutation: CREATE_SCM_FILE,
    variables: {
      parentId,
      link: link[0].link,
      name: link[0].name,
      organizationId,
    },
  });
};
